import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30efe786"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emojis-selection" }

import { EMOJI_CHARACTERS } from "@/data/emoji/emojiCharacters";
import EmojiItem from "../EmojiItem/EmojiItem.vue";

interface Emits {
  (e: "insert-emoji", emoji: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmojisSelection',
  emits: ["insert-emoji"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const insertEmoji = (emoji: string) => {
  emit("insert-emoji", emoji);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EMOJI_CHARACTERS), (emoji, i) => {
      return (_openBlock(), _createBlock(EmojiItem, {
        key: i,
        emoji: emoji,
        onInsertEmoji: insertEmoji
      }, null, 8, ["emoji"]))
    }), 128))
  ]))
}
}

})